import PropTypes from 'prop-types';
import {QRCodeCanvas} from 'qrcode.react';
import React, {useRef, useImperativeHandle, forwardRef} from 'react';
import {Icon} from 'semantic-ui-react';
import * as Yup from 'yup';

import styles from './QrCode.module.scss';

const QrCode = forwardRef(({url}, ref) => {
  const canvasRef = useRef();
  const urlSchema = Yup.string().url();

  // Expose a download function to the parent component
  useImperativeHandle(ref, () => ({
    download: () => {
      const canvas = canvasRef.current;
      if (canvas) {
        const pngUrl = canvas.toDataURL('image/png');
        const downloadLink = document.createElement('a');
        downloadLink.href = pngUrl;
        downloadLink.download = `${encodeURIComponent(url)}_qr_code.png`;
        downloadLink.click();
      } else {
        console.warn('No canvas found for QR download.');
      }
    },
  }));

  urlSchema.validate(url).catch(_error => {
    console.warn('QrCode: Invalid or missing QR code URL: ', url);
    return null;
  });

  return (
    <div className={styles.MainContent}>
      <div className={styles.QrCode}>
        <QRCodeCanvas value={url} size={220} ref={canvasRef} />
      </div>

      <div className={styles.Message}>
        <div className={styles.InnerMessage}>
          <div className={styles.Header}>
            <Icon name="info" />
            Single-use QR code
          </div>
          <div className={styles.Content}>
            The QR code is generated locally in your browser and is not stored or tracked anywhere.
          </div>
        </div>
      </div>
    </div>
  );
});

QrCode.displayName = 'QrCode';

QrCode.propTypes = {
  url: PropTypes.string.isRequired,
};

export default QrCode;
